import {createHashRouter, Navigate} from "react-router-dom";
import {HomePage} from "../../Pages/HomePage";
import {LoginPage} from "../../Pages/LoginPage";
import {MainLayout} from "../Components/Layouts/MainLayout/MainLayout";
import {PlayerScenarioLayout} from "../Components/Layouts/PlayerScenarioLayout/PlayerScenarioLayout";
import {PlayerScenarioPage} from "../../Pages/PlayerScenarioPage";
import {TestSpeechSynthesisPage} from "../../Pages/TestSpeechSynthesisPage";
import {TrustyGamePage} from "../../Pages/TrustyGamePage";
import {TmpPage} from "../../Pages/TmpPage";
import {AppLoader} from "../Components/AppLoader";


const router = createHashRouter([
    {
        path: "/", element: <AppLoader/>, children: [
            {
                path: "/", element: <MainLayout/>, children: [
                    {path: "tmp", element: <TmpPage/>}
                ]
            },
            {
                path: "/", element: <PlayerScenarioLayout/>, children: [
                    {index: true, element: <Navigate to={"test"} replace/>},
                    {path: "home", element: <HomePage/>},
                    {path: "login", element: <LoginPage/>},
                    {path: "english/:id/:scenarioId", element: <PlayerScenarioPage/>},
                    {path: "test", element: <TestSpeechSynthesisPage/>},
                    {path: "game/trusty/:id", element: <TrustyGamePage/>},
                ]
            },
            {path: "*", element: <h1>NoPage</h1>}
        ]
    },

])

export {router};